import React from "react";
import styled from "styled-components";
import { useMutation, queryCache } from "react-query";
import { Col, Row, Button, Input, DatePicker, Select, Typography } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { NotificationStateContext } from "context/UI/Notification/NotificationState";
import { apiAxios } from "services/HttpServices";
import { removeEmptyFields } from "lib/utils";

const { Text } = Typography;

const createDateline = async ({ jobId, dateline }) => {
  console.log("jobId :>> ", jobId);
  console.log("dateline :>> ", dateline);
  try {
    const res = await apiAxios.post(`/jobs/${jobId}/dateline`, [dateline]);
    return res.data.data;
  } catch (e) {
    throw e.response.data.message;
  }
};

const CreateDateline = (props) => {
  // Component Props
  const { jobId, setShowCreateDateline } = props;

  // React Hook Form
  const { control, handleSubmit, reset, setValue, formState } = useForm();

  // Component State
  const [error, setError] = React.useState(null);

  // Component Context
  const {
    state: notificationState,
    setLoading,
    finishLoading,
  } = React.useContext(NotificationStateContext);

  // React Query Mutate
  const [mutateCreate] = useMutation(createDateline, {
    onSuccess: (datelineData, variables) => {
      console.log("datelineData :>> ", datelineData);
      queryCache.setQueryData(
        ["job-detail", variables.jobId.toString()],
        function (oldData) {
          oldData.dateline = [datelineData[0], ...oldData.dateline];
          return oldData;
        }
      );
      reset();
      setShowCreateDateline(false);
    },
    onError: (e) => {
      setError(e);
    },
  });

  // Component Function
  const handleSubmitData = async (data) => {
    console.log("jobId :>> ", jobId);
    setError("");
    const dataToSubmit = {
      title: data.title,
      due_at: data.due_at ? data.due_at.format() : "",
    };

    removeEmptyFields(dataToSubmit);
    setLoading("createDateline");
    try {
      await mutateCreate({
        jobId,
        dateline: dataToSubmit,
      });
      finishLoading("createDateline");
    } catch (error) {
      finishLoading("createDateline");
      console.log(error);
    }
  };

  return (
    <StyledCol xs={24}>
      <Row justify="end">
        <CloseButton
          size="small"
          icon={<CloseCircleFilled style={{ color: "grey" }} />}
          onClick={() => setShowCreateDateline(false)}
        >
          Close
        </CloseButton>
      </Row>
      {error && <ErrorContainer>{error}</ErrorContainer>}
      <form onSubmit={handleSubmit(handleSubmitData)}>
        <Row gutter={8}>
          <Col xs={16}>
            <StyledInput>
              <Text className="title">Title</Text>
              <Controller
                as={<Input autoFocus={true} />}
                name="title"
                placeholder="Dateline title"
                control={control}
              />
            </StyledInput>
          </Col>

          <Col xs={8}>
            <StyledInput>
              <Text className="title">Due date</Text>
              <Controller
                as={DatePicker}
                name="due_at"
                control={control}
                defaultValue=""
                style={{ width: "100%" }}
              />
            </StyledInput>
          </Col>
        </Row>

        <Row gutter={8}>
          <Col xs={18}>
            <Button
              htmlType="submit"
              type="primary"
              loading={notificationState.loading.createDateline}
              block
            >
              Create Dateline
            </Button>
          </Col>
          <Col xs={6}>
            <Button
              htmlType="submit"
              onClick={() => setShowCreateDateline(false)}
              block
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </form>
    </StyledCol>
  );
};

const StyledCol = styled(Col)`
  padding: ${(props) => props.theme.spacing[2]};
`;

const StyledInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${(props) => props.theme.spacing[2]};

  .title {
    font-size: 0.8rem;
    color: ${(props) => props.theme.colors.grey[600]};
  }
`;

const CloseButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.grey[300]};
  color: ${(props) => props.theme.colors.grey[600]};
  border-color: ${(props) => props.theme.colors.grey[400]};
  border-radius: 9999px;
  padding-left: ${(props) => props.theme.spacing[2]};
  padding-right: ${(props) => props.theme.spacing[2]};
`;

const ErrorContainer = styled.div`
  padding: ${(props) => props.theme.spacing[2]};
  background-color: ${(props) => props.theme.colors.red[100]};
  border: 1px solid ${(props) => props.theme.colors[700]};
  font-weight: 600;
  color: ${(props) => props.theme.colors.red[500]};
  margin-bottom: ${(props) => props.theme.spacing[2]};
  margin-top: ${(props) => props.theme.spacing[2]};
`;

export default CreateDateline;
